import React, { useCallback, useEffect } from 'react';
import { hasCatalogProcessingErrors } from '@backstage/plugin-catalog';
import { useGroupType } from '../../hooks/useGroupType';
import { entityWarningContent } from './content/entityWarningContent';
import { CopPage } from './pages/CustomizedGroupPage';
import { GroupPage } from './pages/GroupPage';
import { NonPeopleAppGroupPage } from './pages/NonPeopleAppGroupPage';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  fetchData,
  urls,
} from '@internal/backstage-plugin-dh-dock-shared-common';
import { setSelectedGroups } from '../../redux/slices/globalVariableSlice';
import { useDispatch } from 'react-redux';

const GroupPageSwitch = () => {
  const dispatch = useDispatch();

  const { isCopPage, isOthers } = useGroupType();
  const { entity } = useEntity();
  const getDocName = useCallback(async () => {
    const docName = await fetchData(
      `${urls.fetchDocNameByGroupName}${entity.metadata.name}`,
    );
    dispatch(setSelectedGroups(docName));
  }, []);

  useEffect(() => {
    getDocName();
  }, [getDocName]);

  const warningContent = entityWarningContent(async (entity, context) => {
    try {
      return await hasCatalogProcessingErrors(entity, context);
    } catch (error) {
      console.error('Error evaluating catalog processing errors:', error);
      return false;
    }
  });

  // Check if parent group is dh_digitalhangarnonpeopleappgroups
  const parentGroup = entity?.spec?.parent as string | undefined;
  const isNonPeopleAppGroup = parentGroup?.toLowerCase().includes('dh_digitalhangarnonpeopleappgroups');

  // Show NonPeopleAppGroupPage for non-people app groups
  if (isNonPeopleAppGroup) {
    return <NonPeopleAppGroupPage entityWarningContent={warningContent} />;
  }

  if (isCopPage || isOthers) {
    return <CopPage entityWarningContent={warningContent} />;
  }

  return <GroupPage entityWarningContent={warningContent} />;
};

export default GroupPageSwitch;
